import { addPraise, addCollect, getVideInfo, getSceneHotspots } from '@/api'
import { sleep } from '@/utils'

// import {
//   setStorage,
//   getStorage
// } from '@/utils/storage'

// import {
//   STORAGE_ZAN
// } from '@/config/contant'

const types = {
  VIDEO_ID: 'VIDEO_ID',
  VIDEO_DATA: 'VIDEO_DATA',
  VIDEO_ZAN: 'VIDEO_ZAN',
  ADD_COLLECT: 'ADD_COLLECT',
  ZAN_COUNT: 'ZAN_COUNT',
  COLLECT_COUNT: 'COLLECT_COUNT',
  VIDEO_COLLECTION: 'VIDEO_COLLECTION',
  VIDEO_SCENE_HOTSPOTS: 'VIDEO_SCENE_HOTSPOTS',
  CLEAR_SCENE_HOTSPOTS: 'CLEAR_SCENE_HOTSPOTS',
}

const panoVideo = {
  state: {
    [types.VIDEO_ID]: 0,
    [types.VIDEO_DATA]: {},
    [types.VIDEO_ZAN]: false,
    [types.ZAN_COUNT]: 0,
    [types.VIDEO_COLLECTION]: false,
    [types.VIDEO_SCENE_HOTSPOTS]: [],
    [types.CLEAR_SCENE_HOTSPOTS]: null,
  },
  actions: {
    // 获取视频信息
    [types.VIDEO_DATA]: async ({ dispatch, commit }, videoId) => {
      const res = await getVideInfo(videoId)
      dispatch('VIDEO_ID', videoId)
      dispatch('SCENE_LIST', res.scene_list)
      commit(types.VIDEO_DATA, res)
      return res
    },
    // 切换视频ID
    [types.VIDEO_ID]: async ({ commit }, videoId) => {
      return commit(types.VIDEO_ID, videoId)
    },
    // 切换视频ID
    [types.VIDEO_COLLECTION]: async ({ commit }) => {
      return commit(types.VIDEO_COLLECTION)
    },
    // 获取视频中的热点
    [types.VIDEO_SCENE_HOTSPOTS]: async ({ dispatch, commit }, sceneId) => {
      const data = await getSceneHotspots(sceneId)
      window.$VM.$krp.addHotspotToScene(data)
      dispatch('SCENE_INFO', sceneId)
      return commit(types.VIDEO_SCENE_HOTSPOTS, { sceneId, data })
    },
    [types.CLEAR_SCENE_HOTSPOTS]: async ({ state, commit }) => {
      // window.$VM.$krp.clearHotspotFormScene()
      return commit(types.CLEAR_SCENE_HOTSPOTS)
    },
    [types.VIDEO_ZAN]: async ({ rootGetters, dispatch, commit }) => {
      const hasToken = await dispatch('HAS_TOKEN')
      if (hasToken) {
        const r = await addPraise(rootGetters.getVideoId, hasToken)
        // let msg = r.ispraise ? '点赞成功' : '取消点赞'
        // window.$VM.$vgo.tip(msg, 'success')
        return commit(types.VIDEO_ZAN, r)
      } else {
        dispatch('TOGGLE_LOGIN')
      }
    },
    [types.ADD_COLLECT]: async ({ rootGetters, dispatch, commit }) => {
      const hasToken = await dispatch('HAS_TOKEN')
      if (hasToken) {
        let flag = false
        if (!rootGetters.getVideoCollect) {
          flag = true
          await addCollect(rootGetters.getVideoId, hasToken)
          window.$VM.$vgo.tip('收藏成功', 'success')
        } else {
          window.$VM.$vgo.tip('取消收藏', 'success')
        }
        commit(types.VIDEO_COLLECTION, flag)
      } else {
        dispatch('TOGGLE_LOGIN')
      }
    },
  },
  mutations: {
    [types.VIDEO_ID]: (state, videoId) => {
      state[types.VIDEO_ID] = videoId
    },
    [types.VIDEO_COLLECTION]: (state, flag) => {
      state[types.VIDEO_COLLECTION] = flag
    },
    [types.VIDEO_DATA]: (state, res) => {
      state[types.VIDEO_DATA] = res
      state[types.VIDEO_COLLECTION] = res.is_collect
      state[types.ZAN_COUNT] = res.praisecount
    },
    [types.VIDEO_SCENE_HOTSPOTS]: async (state, obj) => {
      state[types.VIDEO_SCENE_HOTSPOTS] = []
      await sleep(1000)
      obj.data.map(it => {
        it.mat_pic = JSON.parse(it.datastr).cover
        it.mat_file = JSON.parse(it.datastr).url
      })
      state[types.VIDEO_SCENE_HOTSPOTS] = obj.data
    },
    [types.CLEAR_SCENE_HOTSPOTS]: state => {
      state[types.VIDEO_SCENE_HOTSPOTS] = []
    },
    [types.VIDEO_ZAN]: (state, data) => {
      state[types.VIDEO_ZAN] = data.ispraise
      state[types.ZAN_COUNT] = data.praise_count
    },
  },
  getters: {
    getVideoId(state) {
      return state[types.VIDEO_ID]
    },
    getVideoInfo(state) {
      return state[types.VIDEO_DATA]
    },
    getRollFont(state) {
      return state[types.VIDEO_DATA].rollfont
    },
    getVideoHotspots(state) {
      return state[types.VIDEO_SCENE_HOTSPOTS]
    },
    getVideoZan(state) {
      return state[types.VIDEO_ZAN]
    },
    getVideoCollect(state) {
      return state[types.VIDEO_COLLECTION]
    },
    getVideoZanCount(state) {
      return state[types.ZAN_COUNT]
    },
  },
}

export default panoVideo
